export const answerInitial = {
  answerValue: "",
  csiAnswers: [],
};
